import { render, staticRenderFns } from "./Embarcaciones.vue?vue&type=template&id=28ebeb26"
import script from "./Embarcaciones.vue?vue&type=script&lang=js"
export * from "./Embarcaciones.vue?vue&type=script&lang=js"
import style0 from "./Embarcaciones.vue?vue&type=style&index=0&id=28ebeb26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports